<template>
  <v-card :flat="isSettingsStyle">
    <v-card-text>

      <v-form v-model="isFormValid">
        <SubscriptionBaseData
          :address-keys="addressKeys"
          :card="card"
          :error-messages="errorMessages"
        />

        <v-flex xs12>
          <h3 class="subheading my-2">{{ $t('paymentData') }}</h3>
        </v-flex>
        <v-flex xs12>
          <div class="StripeElementGroup mx-3">
            <div
              id="card-element"
              tabindex="1">
              <!-- A Stripe Element will be inserted here. -->
            </div>
            <span class="highlight"/>
            <span class="bar"/>
            <!-- Used to display form errors. -->
            <div
              id="card-errors"
              role="alert"
              class="v-messages red--text text--darken-1"/>
          </div>
        </v-flex>
      </v-form>

    </v-card-text>

    <v-card-actions>
      <v-spacer/>
      <v-btn
        flat
        @click="$emit('changePaymentMethod')"
      >
        {{ $t('choosePaymentMethod') }}
      </v-btn>
      <v-btn
        :disabled="!isCompleted || !isFormValid || isLoading"
        :loading="isLoading"
        color="primary"
        @click="next"
      >
        {{ $t(isSettingsStyle ? 'updatePaymentType' : 'next') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import style from './stripeStyle'
import SubscriptionBaseData from '@/components/routes/subscription/SubscriptionBaseData'

export default {
  name: 'SubscriptionCardElement',
  components: { SubscriptionBaseData },
  props: ['stripe', 'isSettingsStyle', 'isLoading'],
  data () {
    return {
      isCompleted: false,
      isFormValid: false,
      element: null,
      errorMessages: {},
      card: {
        name: '',
        address_line1: '',
        address_line2: '',
        address_city: '',
        address_state: '',
        address_zip: '',
        address_country: this.$t('country'),
        company_name: ''
      },
      addressKeys: [
        'company_name',
        'name',
        'address_line1',
        'address_line2',
        'address_state',
        'address_zip',
        'address_city',
        'address_country'
      ]
    }
  },
  computed: {
    ...mapGetters('user', ['getUser'])
  },
  methods: {
    next () {
      this.$emit('complete', { element: this.element, data: this.card })
    },

    fillUpBillingData () {
      const billingData = Object.assign({}, this.getUser.billing_data)

      if (this.getUser.billing_data) {
        billingData.name = this.getUser.billing_data.name
        billingData.company_name = this.getUser.billing_data.company_name
      } else {
        billingData.name = `${this.getUser.first_name} ${this.getUser.last_name}`
        billingData.company_name = this.getUser.company_data ? this.getUser.company_data.name : ''
      }

      billingData.address_line2 = billingData.address_line2 || ''

      Object.assign(this.card, billingData)
    }
  },
  mounted () {
    const elements = this.stripe.elements({ locale: 'auto' })
    this.element = elements.create('card', { style })
    this.element.mount('#card-element')

    const errorMessage = document.getElementById('card-errors')

    this.element.addEventListener('change', event => {
      this.isCompleted = event.complete

      errorMessage.textContent = event.error ? event.error.message : ''
    })
  },
  created () {
    this.fillUpBillingData()
  },
  i18n: {
    messages: {
      de: {
        paymentData: 'Bezahlinformationen',
        updatePaymentType: 'Zahlungsart aktualisieren',
        next: 'Weiter',
        choosePaymentMethod: 'Zurück',
        country: 'Deutschland'
      },
      en: {
        paymentData: 'Payment information',
        updatePaymentType: 'Update payment type',
        next: 'Next',
        country: 'Germany',
        choosePaymentMethod: 'Back'
      },
      tr: {
        paymentData: 'Ödeme bilgisi',
        updatePaymentType: 'Ödeme türünü güncelleyin',
        next: 'Ayrıca',
        country: 'Almanya',
        choosePaymentMethod: 'Geri'
      },
      ru: {
        paymentData: 'Информация об оплате',
        updatePaymentType: 'Обновить способ оплаты',
        next: 'Дальше',
        country: 'Германия',
        choosePaymentMethod: 'Назад'
      }
    }
  }
}
</script>
